import React, {useContext, useEffect} from "react"
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import {getRefreshInterval} from "../util/Util";
import {CapabilityContext} from "../global/context/CapabilityContext";
import AssociatePerformanceView from "./AssociatePerformanceView";
import AssociateDetailViewV2 from "./AssociateDetailViewV2";

const AssociatePerformanceV2 = (props) => {
    const {dispatch} = useContext(AssociatePerformanceContext);
    const {configViewModel} = useContext(CapabilityContext)

    const getData = () => {
        dispatch({
            type: 'LOAD_VIEW',
            data: {
                dispatcher: dispatch,
                baseUrl: configViewModel.baseUrl,
                stationConfig: configViewModel.stationConfig
            }
        });
    }

    useEffect(() => {
        getData()
        const interval = setInterval(() => {
            getData()
        }, getRefreshInterval(configViewModel.stationConfig));
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            {!props.associate ? <AssociatePerformanceView {...props}/> : <AssociateDetailViewV2 {...props}/>}
        </div>
    );
}

export default AssociatePerformanceV2


// WEBPACK FOOTER //
// ./src/components/pickassociate/AssociatePerformanceV2.js